import React from 'react';
import { Layout, Button, Space, Tooltip } from 'antd';
import { LogoutOutlined, ReloadOutlined, UserOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import { CitadeloLogo } from './CitadeloLogo';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../hooks/useTheme';

interface CitadeloLayoutProps {
  children: React.ReactNode;
  onRefresh?: () => void;
  onLogout?: () => void;
  showHeader?: boolean;
}

export const CitadeloLayout: React.FC<CitadeloLayoutProps> = ({
  children,
  onRefresh,
  onLogout,
  showHeader = true
}) => {
  const navigate = useNavigate();
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Layout style={{ minHeight: '100vh', background: isDarkMode ? '#141414' : '#f8f9fa' }}>
      {showHeader && (
        <Layout.Header style={{ 
          background: isDarkMode ? '#1f1f1f' : '#1a1a2e', 
          padding: '0 24px',
          boxShadow: isDarkMode ? '0 2px 8px rgba(0, 0, 0, 0.45)' : '0 2px 8px rgba(26, 26, 46, 0.1)'
        }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            <div style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
              <CitadeloLogo size="small" variant="full" theme="light" />
            </div>
            <Space>
              <Tooltip title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
                <Button
                  type="default"
                  ghost
                  className="citadelo-header-btn"
                  icon={isDarkMode ? <SunOutlined /> : <MoonOutlined />}
                  onClick={toggleTheme}
                />
              </Tooltip>
              <Button
                type="default"
                ghost
                className="citadelo-header-btn"
                icon={<UserOutlined />}
                onClick={() => navigate('/profile')}
              >
                My Profile
              </Button>
              {onRefresh && (
                <Button 
                  type="default"
                  ghost
                  className="citadelo-header-btn"
                  icon={<ReloadOutlined />} 
                  onClick={onRefresh}
                >
                  Refresh
                </Button>
              )}
              {onLogout && (
                <Button 
                  type="default"
                  ghost
                  className="citadelo-header-btn"
                  icon={<LogoutOutlined />} 
                  onClick={onLogout}
                >
                  Logout
                </Button>
              )}
            </Space>
          </div>
        </Layout.Header>
      )}

      <Layout.Content style={{ padding: '24px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {children}
        </div>
      </Layout.Content>
    </Layout>
  );
};

export default CitadeloLayout;

